import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as planActions, fetchPlannerWithFilters } from '../store/slice';
import { selectPlanFilters, selectFilteredPlans } from '../store/selectors';
import { parseISO, addDays, format, min, max } from 'date-fns';

//const { setSearchText } = planActions;

// new code(Status filter )

const { setSearchText } = planActions;

const statusOptions = [
  'Open',
  'In Planning',
  'Pre Release',
  'In Production',
  'On Hold',
  'Machine Down',
  'Maintenance',
  'Completed',
];

const Filter = ({ onHandleSearch, start, end }) => {
  const dispatch = useDispatch();

  //new code(Status filter )
  // const filters = useSelector(state => state.planner.filters);

  const { searchText } = useSelector(selectPlanFilters);
  const [searchTextLocal, setSearchTextLocal] = useState(searchText || '');

  console.log('start:', start);
  console.log('end:', end);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('All');
  const programs = useSelector(selectFilteredPlans);

  // Debounced Keyword Search
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      dispatch(setSearchText(searchTextLocal));
      dispatch(fetchPlannerWithFilters());
    }, 500);

    return () => clearTimeout(searchTimeout.current);
  }, [searchTextLocal]);

  useEffect(() => {
    setFromDate(() => {
      try {
        return format(parseISO(start), 'yyyy-MM-dd');
      } catch (error) {
        console.error('Invalid start date:', start, error);
        return '';
      }
    });

    setToDate(() => {
      try {
        return format(parseISO(end), 'yyyy-MM-dd');
      } catch (error) {
        console.error('Invalid end date:', end, error);
        return '';
      }
    });
  }, [start, end]);

  const onSearch = () => {
    dispatch(setSearchText(searchTextLocal));

    if (fromDate != '' && toDate != null && searchTextLocal == '') {
      onHandleSearch(fromDate, toDate, status);
    } else if (searchTextLocal != '') {
      const sinceDates = programs.map(p => parseISO(p.since));
      const tillDates = programs.map(p => parseISO(p.till));

      if (sinceDates.length === 0 || tillDates.length === 0) {
        return;
      }

      const fromDateObj = fromDate ? new Date(fromDate) : null;
      const toDateObj = toDate ? new Date(toDate) : null;

      let finalFrom;
      let finalTo;

      // Filter sinceDates >= fromDateObj, and get the **min** of them
      if (fromDateObj) {
        const filteredSince = sinceDates.filter(date => date >= fromDateObj);
        finalFrom = filteredSince.length > 0 ? min(filteredSince) : min(sinceDates);
      } else {
        finalFrom = min(sinceDates);
      }
      // Filter tillDates <= toDateObj, and get the **max** of them
      if (toDateObj) {
        const filteredTill = tillDates.filter(date => date <= toDateObj);
        const maxTill = filteredTill.length > 0 ? max(filteredTill) : max(tillDates);
        finalTo = maxTill; // your original logic to add 1 day
      } else {
        finalTo = max(tillDates);
      }

      const formattedSince = format(finalFrom, 'yyyy-MM-dd');
      const formattedTill = format(finalTo, 'yyyy-MM-dd');

      onHandleSearch(formattedSince, formattedTill, status);
    }
  };

  let searchTimeout = useRef(null);

  //new code(status filter)

  // const handleStatusChange = event => {
  //   dispatch(setStatus(event.target.value));
  // };

  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextLocal(newSearchText);
    dispatch(setSearchText(newSearchText));
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row align-items-end justify-content-between">
          {/* Search Input */}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12">
            <div className="input-blocks">
              <label>Search</label>
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter a keyword"
                  value={searchTextLocal}
                  onChange={handleSearch}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-8 col-sm-12">
            <div className="d-flex justify-content-end gap-3 flex-wrap align-items-end">
              {/* From Date */}
              <div className="input-blocks">
                <label>
                  From<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  value={fromDate || ''}
                  onChange={e => setFromDate(e.target.value)}
                  className="form-control"
                />
              </div>

              {/* latest code */}
              {/* <input
                  type="date"
                  value={fromDate || ''}
                  onChange={e => {
                    setFromDate(e.target.value);
                    dispatch({
                      type: 'planner/setFilters',
                      payload: { ...filters, start: e.target.value },
                    });
                  }}
                  className="form-control"
                />
              </div> */}

              {/* To Date */}
              <div className="input-blocks">
                <label>
                  To<span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  value={toDate || ''}
                  onChange={e => setToDate(e.target.value)}
                  className="form-control"
                />
              </div>
              {/* latest code */}
              {/* <input
                  type="date"
                  value={toDate || ''}
                  onChange={e => {
                    setToDate(e.target.value);
                    dispatch({
                      type: 'planner/setFilters',
                      payload: { ...filters, end: e.target.value },
                    });
                  }}
                  className="form-control"
                />
              </div> */}

              {/* new code Status Dropdown (commented out) */}

              <div className="input-blocks">
                <label>Status</label>
                <select
                  className="form-control"
                  value={status || ''}
                  onChange={e => setStatus(e.target.value)}
                >
                  <option value="All">All</option>
                  {statusOptions.map((status, index) => (
                    <option key={index} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>

              {/* Search Button */}
              <div className="input-blocks">
                <label className="invisible">Search</label>
                <button
                  className="btn btn-warning px-3 d-flex align-items-center"
                  onClick={onSearch}
                >
                  <i className="feather-search me-1" /> Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
